import { Box, BoxProps } from "@chakra-ui/react";

export function MemberListIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 14"
        fill="currentColor"
      >
        <path
          d="M12.4107 12.334H12.7375C13.5041 12.334 14.1138 11.9847 14.6613 11.4964C16.052 10.2557 12.7828 9.00065 11.6667 9.00065M10.3333 2.37983C10.4847 2.3498 10.6419 2.33398 10.8032 2.33398C12.0164 2.33398 13 3.22941 13 4.33398C13 5.43855 12.0164 6.33398 10.8032 6.33398C10.6419 6.33398 10.4847 6.31817 10.3333 6.28814"
          stroke="currentColor"
          stroke-linecap="round"
        />
        <path
          d="M2.98754 9.74144C2.20156 10.1627 0.140758 11.0227 1.39592 12.0989C2.00906 12.6247 2.69194 13.0007 3.55048 13.0007H8.44952C9.30806 13.0007 9.99094 12.6247 10.6041 12.0989C11.8592 11.0227 9.79844 10.1627 9.01246 9.74144C7.16934 8.75372 4.83066 8.75372 2.98754 9.74144Z"
          stroke="currentColor"
        />
        <path
          d="M8.66667 4.00065C8.66667 5.47341 7.47276 6.66732 6 6.66732C4.52724 6.66732 3.33333 5.47341 3.33333 4.00065C3.33333 2.52789 4.52724 1.33398 6 1.33398C7.47276 1.33398 8.66667 2.52789 8.66667 4.00065Z"
          stroke="currentColor"
        />
      </svg>
    </Box>
  );
}
